<template>
  <el-form
    class="all_info"
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="auto"
  >
    <div class="head-img">
      <el-tooltip
        class="item"
        effect="light"
        content="点击上传头像"
        placement="top"
      >
        <el-upload
          action="#"
          class="avatar-uploader"
          :headers="{ uploadType: 'doctor_profile' }"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :auto-upload="true"
          multiple
        >
          <img
            v-if="ruleForm.avatarResult"
            :src="ruleForm.avatarResult"
            class="avatar"
          />
          <img
            v-else
            src="../../../../../assets/images/default-avatar-doctor.png"
            class="avatar"
          />
        </el-upload>
      </el-tooltip>
      <div class="head-img-br">
        <span class="head-img-br-span"
          >头像照片需上传本人免冠正脸清晰职业照，生活照将无法通过审核</span
        >
        <span class="head-img-check" @click="checkPhoto">查看实例</span>
        <img
          v-show="headPortrait"
          class="headPortrait"
          src="../../../../../assets/images/default-avatar-doctor.png"
          alt=""
        />
      </div>
    </div>
    <!-- </el-tooltip> -->
    <!-- </el-form-item> -->
    <!-- </el-col> -->
    <!-- </el-row> -->
    <el-form-item label="医生姓" prop="familyName">
      <el-input
        class="form-item-info"
        v-model="ruleForm.familyName"
        placeholder="请输入医生姓"
      ></el-input>
    </el-form-item>
    <el-form-item label="医生名" prop="firstName">
      <el-input
        class="form-item-info"
        v-model="ruleForm.firstName"
        placeholder="请输入医生名"
      ></el-input>
    </el-form-item>
    <el-form-item label="身份证号" prop="identityCard">
      <el-input
        class="form-item-info"
        v-model="ruleForm.identityCard"
        placeholder="请输入身份证号"
        @blur="cardWatch()"
      ></el-input>
    </el-form-item>
    <el-form-item class="el-form-item-info-sex" label="性别" prop="gender">
      <el-radio-group v-model="ruleForm.gender">
        <el-radio label="10901">男</el-radio>
        <el-radio label="10902">女</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item class="el-form-item-info" label="出生日期" prop="birthday">
      <el-date-picker
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择日期"
        v-model="ruleForm.birthday"
        class="form-item-info"
        :picker-options="pickerOptions0"
      ></el-date-picker>
    </el-form-item>
    <el-form-item class="el-form-item-info" label="选择城市" prop="provinceId">
      <div class="block">
        <el-select
          v-model="ruleForm.provinceId"
          placeholder="请选择城市"
          @change="handleChange"
        >
          <el-option
            v-for="item in cityList"
            :key="item.areaId"
            :label="item.mername"
            :value="item.areaId"
          />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item class="el-form-item-info" label="所属医院" prop="hospitalId">
      <el-select
        class="form-item-info"
        v-model="ruleForm.hospitalId"
        filterable
        placeholder="请选择所属医院"
        no-data-text="请选择所属医院"
        @change="getDepartment"
      >
        <el-option
          v-for="(item, index) in hospitalList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      class="el-form-item-info"
      label="所属科室"
      prop="departmentName"
    >
      <!-- <el-select class="form-item-info" v-model="ruleForm.departmentId" filterable placeholder="请选择所属科室" no-data-text="请选择所属科室">
        <el-option v-for="(item, index) in departmentList" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select> -->
      <el-input
        v-model="ruleForm.departmentName"
        @focus="departmentResult = true"
        placeholder="请选择科室"
      >
      </el-input>
    </el-form-item>
    <el-form-item class="el-form-item-info" label="擅长领域" prop="adept">
      <el-input
        class="form-item-info"
        type="textarea"
        :rows="3"
        v-model="ruleForm.adept"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <div class="loginBtn">
        <!-- <el-button
          style="width: 100%"
          v-if="ruleForm.status === 0 || ruleForm.status === -1"
          class="customBtn"
          type="primary"
          @click="submitForm('ruleForm')"
          >保存并下一步</el-button
        > -->
        <el-button
          style="width: 100%"
          class="customBtn"
          type="primary"
          @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </div>
    </el-form-item>
    <el-dialog :visible.sync="departmentResult" width="40%" center>
      <DepartmentList @on_disease_code="on_disease_code" />
    </el-dialog>
  </el-form>
</template>
<script>
import util from "@/utils";
import config from "@/config/config.js";
import {
  doctorEdit,
  getHospital,
  getCityList,
  batchUpload,
} from "@/api/index.js";
import DepartmentList from "@/components/departmentList/DepartmentList.vue";

import { getDoctorInformation } from "@/api";

export default {
  components: {
    DepartmentList,
  },
  props: {
    userData: Object,
  },
  data() {
    return {
      ImageUrl: config.ImageUrl,
      uploadUrl: process.env.VUE_APP_BASE_API + "/upload/batchUpload",
      Host: "http://doctor.ifarmiot.com/",
      hospitalList: "",
      // departmentList: "",
      SetKey: {
        value: "id",
        label: "title",
        children: "children",
      },
      genderList: [
        {
          label: "男",
          value: "1",
        },
        {
          label: "女",
          value: "2",
        },
      ],
      ruleForm: {},
      rules: {
        familyName: [
          {
            required: true,
            message: "请输入医生姓",
            trigger: "blur",
          },
          {
            min: 1,
            max: 8,
            message: "长度在 1 到 8 个字符",
            trigger: "blur",
          },
        ],
        firstName: [
          {
            required: true,
            message: "请输入医生名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 8,
            message: "长度在 1 到 8 个字符",
            trigger: "blur",
          },
        ],
        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
        provinceId: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        avatarResult: [
          {
            required: true,
            message: "请上传头像",
            trigger: "change",
          },
        ],
        hospitalId: [
          {
            required: true,
            message: "请选择所属医院",
            trigger: "change",
          },
        ],
        departmentName: [
          {
            required: true,
            message: "请选择所属科室",
            trigger: "change",
          },
        ],
        adept: [
          {
            required: true,
            message: "请输入自我介绍",
            trigger: "blur",
          },
        ],
      },
      value: [],
      cityList: [],
      pickerOptions0: {
        //elementUI不能选择超过当天的日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      departmentResult: false,
      active: 1,
      headPortrait: false,
    };
  },
  mounted() {
    this.readyCityList();
    this.getUserInfo();
    this.$store.commit("updateActive", 1);
  },
  created() {
    this.getDoctorInfo();
  },
  methods: {
    // 获取医生信息
    async getDoctorInfo() {
      try {
        let { code, data } = await getDoctorInformation();
        if (code === 1) {
          this.ruleForm = data;
        }
      } catch (error) {}
    },

    /**
     * 截取身份证信息
     */
    cardWatch() {
      let card = this.ruleForm.identityCard;
      if (card == undefined) return;
      if (card != "" && card.length == 15) {
        const year = `19${card.substr(6, 2)}`;
        const month = card.substr(8, 2);
        const day = card.substr(10, 2);

        var year_reg = /^(19|20)\d{2}$/;
        if (!year_reg.test(year)) {
          // this.$toast("身份证号码·年份·输入有误，无法读取生日");
          return;
        }
        if (month > 12) {
          // this.$toast("身份证号码·月份·输入有误，无法读取生日");
          return;
        }
        if (day > 31) {
          // this.$toast("身份证号码·日期·输入有误，无法读取生日");
          return;
        }
        const gender_code = card.substr(14, 1);
        if (gender_code % 2 == 0) {
          this.ruleForm.gender = "2";
        } else {
          this.ruleForm.gender = "1";
        }
        this.ruleForm.birthday = `${year}-${month}-${day}`;
        console.log(this.birthday, " this.birthday");
      } else if (card != "" && card.length == 18) {
        const year = card.substr(6, 4);
        const month = card.substr(10, 2);
        const day = card.substr(12, 2);

        var year_reg = /^(19|20)\d{2}$/;
        if (!year_reg.test(year)) {
          this.$toast("身份证号码·年份·输入有误，无法读取生日");
          return;
        }
        if (month > 12) {
          this.$toast("身份证号码·月份·输入有误，无法读取生日");
          return;
        }
        if (day > 31) {
          this.$toast("身份证号码·日期·输入有误，无法读取生日");
          return;
        }
        const gender_code = card.substr(16, 1);
        if (gender_code % 2 == 0) {
          this.ruleForm.gender = "2";
        } else {
          this.ruleForm.gender = "1";
        }
        this.ruleForm.birthday = `${year}-${month}-${day}`;
        console.log(this.ruleForm.birthday, " this.birthday");
      } else {
        this.ruleForm.gender = "";
        this.ruleForm.birthday = "";
      }
    },

    checkPhoto() {
      this.headPortrait = !this.headPortrait;
    },
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {};
        let res = await getDoctorInformation(params);
        this.$store.commit("setProfileStep", res.data.profileStep);

        if (res.code) {
          this.ruleForm = res.data;
          this.ruleForm.gender = this.ruleForm.gender.toString();
          this.ruleForm.avatarResult = res.data.avatar;
          this.readyHospital(this.ruleForm.provinceId);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 保存信息
     */
    submitForm(formName) {
      //验证姓名是否符合真实姓名
      // let regName = /^[\u4e00-\u9fa5]{2,4}$/;
      // if (!regName.test(this.ruleForm.name)) {
      //   this.$message({
      //     showClose: true,
      //     message: "请输入真实姓名",
      //   });
      //   return false;
      // }
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            // const params = {
            //   doctor: this.ruleForm,
            //   jsonPlan: this.ruleForm.jsonPlan,
            // };
            let res = await doctorEdit(this.ruleForm);
            if (res.code) {
              this.elementTips("success", res.message);
              this.getUserInfo();
              if (this.ruleForm.status === 0 || this.ruleForm.status === -1) {
                // this.$router.push(
                //   "/index/user/auditInformation/authentication"
                // );
                this.$router.push(
                  "/index/user/userinfo"
                );
              }
            } else {
              this.elementTips("error", res.message);
            }
          } else {
            return false;
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    //城市点击方法
    handleChange(value) {
      console.log(value);
      this.ruleForm.regionId = value;
      this.ruleForm.hospitalId = "";
      this.ruleForm.departmentId = "";
      this.readyHospital(value);
    },
    /**
     * 医院点击
     */
    getDepartment() {
      const that = this;
      let hid = that.ruleForm.hospitalId;
      // this.readyDepartment(hid);
    },
    /**
     * @desc 获取所属城市
     */
    async readyCityList() {
      try {
        let res = await getCityList({});
        if (res.code) this.cityList = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取所属医院
     */
    async readyHospital(provinceId) {
      if (!provinceId) return;
      try {
        const that = this;
        const params = {
          provinceId: provinceId,
          cityId: "",
          districtId: "",
        };
        let res = await getHospital(params);
        if (res.code) {
          console.log(res);
          this.hospitalList = res.data;
          if (that.ruleForm.hospitalId == "") {
            that.ruleForm.hospitalId =
              that.hospitalList.length > 0 ? that.hospitalList[0].id : null;
          }
          if (this.hospitalList.length == "") {
            //当更换城市后所属科室设为空，重新选择
            this.ruleForm.departmentId = "";
          }
          // this.readyDepartment(this.ruleForm.hospitalId);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleAvatarSuccess(res, file) {
      const that = this;
      that.ruleForm.avatar = res.data.relativePath;
      that.ruleForm.avatarText = res.data.absolutePath;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "jpg";
      const isLt200k = file.size / 1024 < 2000;

      if (!isJPG) {
        this.$message.error("头像图片格式错误");
      }
      if (!isLt200k) {
        this.$message.error("上传头像图片大小不能超过 2M!");
      }
      // return isJPG && isLt200k;
      this.fileUpload(file);
    },
    on_disease_code(data, type) {
      this.departmentResult = type;
      this.ruleForm.departmentId = data.id;
      this.ruleForm.departmentName = data.name;
    },
    async fileUpload(fileObj) {
      this.uploadLoading = true;
      const fileData = new FormData();
      fileData.append("files", fileObj);
      const res = await batchUpload(fileData);
      if (res.code) {
        this.uploadLoading = false;
        this.ruleForm.avatar = res.data[0];
      } else {
        this.$message({
          message: "上传文件失败",
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.all_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 400px;
}
.el-button--primary {
  background-color: #fc701a;
  border-color: #fc701a;
}

.head-img {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .head-img-br {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //   display: flex;
    //   align-items: center;
  }
}

.head-img-br span {
  margin: 0 0 14px 10px;
  font-size: 15px;
  color: #999999;
}

.avatar {
  width: 200px;
  height: 200px;
  margin-bottom: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-form-item__label {
  font-size: 16px;
}

/deep/ .form-item-info {
  width: 100%;
}

.information .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.info-left {
  width: 225px;
}
.inf {
  // width: 100%;
  // height: 965px;
  height: 100%;
  padding: 250px;
  padding-top: 39px;
  margin: 0 auto;

  // box-shadow: 0 0 50px #8c939d;
}
/* .inf-content {
  width: 65%;
  margin: 39px auto ;
} */
.row-info {
  .form-info {
    // position: absolute;

    margin: 20px -51% 0% 0;
    margin-left: -100px;
    padding-bottom: 25%;
    // min-width: 1800px;
    background: #ffffff !important;
    .info-col {
      margin: 0 !important;
    }
    .el-form-item-info-sex {
      margin-left: calc(20% - 28px);
      // .el-from-item-info-sex-redio.is-checked {
      //   color: #fc701a !important;
      // }
    }
    .loginBtn {
      width: 20%;
      margin-left: calc(25% + 120px);
      .customBtn {
        background: #fc701a !important;
        border: 0 !important;
      }
    }
  }
}

.form-info .form-item-info {
  width: 60%;
}

.row-info .el-form-item__content {
  margin: 0 !important;
}

.information .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.information .avatar-uploader .el-upload {
  margin-left: calc(45% - 5px);
}

.information .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.information .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.information .el-textarea__inner {
  border-color: #dcdfe6 !important;
}

/deep/.el-input__inner:focus {
  border: 1px solid #fc701a !important;
}
/deep/.el-textarea__inner:focus {
  border: 1px solid #fc701a !important; // 鼠标聚焦边框颜色
}

.el-cascader-node.in-active-path:focus {
  color: #fc701a !important;
}

#el_cascader /deep/ :foucs {
  color: #fc701a !important;
}

/* 选中后的字体颜色 */
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #fc701a !important;
}
/* 选中后小圆点的颜色 */
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #fc701a !important;
  border-color: #fc701a !important;
}
// /deep/.el-popper.el-cascader__dropdown + .el-cascader-panel + .el-scrollbar.el-cascader-menu +.el-cascader-menu__wrap.el-scrollbar__wrap+.el-scrollbar__view.el-cascader-menu__list+ .el-cascader-node.in-active-path + .el-cascader-node__label{
//   color: #fc701A !important;
// }

/deep/.el-radio__input .el-radio__inner:hover {
  border-color: #fc701a !important;
}

/deep/.form-item-info .el-textarea__inner:hover {
  border-color: #fc701a !important;
}
.Notice {
  width: 90%;
  display: flex;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #666;
  text-align: left;
  line-height: 20px;
  margin: 15px auto;
  border: 1px solid #cadff7;
  padding: 10px;
}
.head-img-br .head-img-check {
  font-style: normal;
  font-size: 16px;
  color: #02a7f0;
  cursor: pointer;
  right: 30px;
  bottom: 75px;
  position: absolute;
}
.head-img-br .headPortrait {
  position: absolute;
  right: -195px;
  top: 30px;
}
.hint_info {
  width: 320px;
  height: 275px;
  position: absolute;
  right: -400px;
  top: 10px;
}
.hint_info span {
  font-size: 14px;
  color: #666;
  display: inline-block;
  line-height: 20px;
}
.hint_info span i {
  color: red;
}
.again_btn {
  display: block;
  width: 97px;
  height: 37px;
  margin: 10px auto 0;
}
.alert_text {
  width: 490px;
  margin-left: 20px;
}
.el-col-12 {
  width: 80%;
}
</style>
